<!-- @format -->

<template>
  <div class="ui segment">
    <dx-chart
      style="max-height: 180px; height: 180px;"
      :data-source="topPositions"
    >
      <dx-common-axis-settings>
        <dx-label>
          <dx-font color="black" />
        </dx-label>
      </dx-common-axis-settings>

      <dx-legend :visible="false">
        <dx-font color="black" />
      </dx-legend>
      <dx-series
        :color="appearanceSettings.appearanceSchema.barColor1"
        argument-field="name"
        value-field="value"
        name="Description"
        type="bar"
      />
    </dx-chart>
    <br />

    <div class="ui horizontal divider">Top Holdings</div>

    <table style="font-size: small" class="ui very compact table">
      <thead>
        <tr>
          <th>Description</th>
          <th style="vertical-align: center">%</th>
        </tr>
      </thead>
      <tr v-for="a in selectedPortfolio.positions">
        <td>{{ a.name }}</td>
        <td style="vertical-align: center">
          {{ formatNr(a.weight, "0,0.0") }}%
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { getCustomPortfolio } from "@/gateway";
import numeral from "numeral";
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxValueAxis,
  DxCommonAxisSettings,
  DxCommonSeriesSettings,
  DxGrid,
  DxMargin,
  DxLegend,
  DxTick,
  DxTooltip,
  DxLabel,
  DxFont,
} from "devextreme-vue/chart";
export default {
  name: "Positions",
  props: {
    appearanceSettings: Object,
    projectionRequest: Object,
    selectedPortfolio: Object,
    currentAge: Number,
    selected: Object,
    // selectedPoint: Object,
    show: Boolean,
  },
  components: {
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxCommonAxisSettings,
    DxCommonSeriesSettings,
    DxGrid,
    DxMargin,
    DxLabel,
    DxLegend,
    DxTick,
    DxTooltip,
    DxFont,
  },
  data() {
    return { pointIncomeOptions: { visible: false } };
  },
  computed: {
    topPositions: function() {
      let finalAa = [];
      // for (var i = 0; i < this.chartProjections.length; i++) {
      let p = this.selectedPortfolio.positions;
      let i = 0;
      while (i < 4) {
        if (p[i]) {
          finalAa.push({
            value: p[i].weight,
            name: p[i].name,
          });
        }
        i++;
      }

      return finalAa;
    },
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.00a");
    },
    async init() {
      const response = await getCustomPortfolio({
        loadUnderlyingData: true,
        loadUnderlyingType: "positions",
        id: this.selectedPortfolio.customPortfolioId,
      });
      if (response) {
        this.selectedPortfolio.positions = response.portfolioView.positions;
      }
    },
  },
  async mounted() {
    //  await this.init();
  },
};
</script>
